import base from './base'
import users from './users'
import shared from './shared'
import roles from './roles'
import realms from './realms'
import devices from './devices'
import myDevices from '@/modules/my-devices'
import MyConsulars from '@/modules/my-consulars'

export default {
  MyConsulars,
  base,
  realms,
  devices,
  myDevices,
  roles,
  shared,
  users
}
